import React from 'react';
import { Seo } from '../../components/Seo';
import { site } from '../../config/site';

export default function TermsPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${site.name} — Conditions d’utilisation`,
    url: `${site.url}/conditions`,
    inLanguage: 'fr-FR',
  };

  return (
    <>
      <Seo
        title="Conditions d’utilisation"
        description="Conditions d’utilisation LuckyBetFR: rôle du site, limites, responsabilité, et règles de navigation."
        canonicalPath="/conditions"
        jsonLd={jsonLd}
      />

      <section className="lbf-container py-12 sm:py-16">
        <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">Conditions d’utilisation</h1>
        <p className="mt-4 max-w-3xl text-sm text-zinc-200/85">
          En utilisant LuckyBetFR, tu acceptes ces conditions. On a volontairement écrit court et clair.
        </p>

        <div className="mt-10 grid gap-4">
          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Rôle du site</h2>
            <p className="mt-3 text-sm text-zinc-200/85">
              LuckyBetFR fournit des informations et des comparaisons. Nous ne sommes pas un opérateur de jeu. Les
              conditions officielles des opérateurs priment toujours.
            </p>
          </div>

          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Responsabilité</h2>
            <ul className="mt-4 grid gap-2 text-sm text-zinc-200/85">
              <li>- Les paris sportifs comportent des risques financiers: tu restes responsable de tes décisions.</li>
              <li>- Les informations peuvent évoluer: bonus, conditions, méthodes de paiement.</li>
              <li>- Nous ne garantissons aucun gain ni résultat.</li>
            </ul>
          </div>

          <div className="lbf-card p-6">
            <h2 className="text-xl font-black text-white">Accès 18+</h2>
            <p className="mt-3 text-sm text-zinc-200/85">
              Le contenu est destiné à un public majeur. Si tu n’as pas 18 ans, n’utilise pas ce site.
            </p>
          </div>
        </div>

        <div className="mt-10 text-xs text-zinc-400">
          Dernière mise à jour: 2025-12-17 • Domaine: <span className="font-semibold text-white/80">{site.domain}</span>
        </div>
      </section>
    </>
  );
}


